import { render, staticRenderFns } from "./Red.vue?vue&type=template&id=dc69efb0&scoped=true&"
import script from "./Red.vue?vue&type=script&lang=ts&"
export * from "./Red.vue?vue&type=script&lang=ts&"
import style0 from "./Red.vue?vue&type=style&index=0&id=dc69efb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc69efb0",
  null
  
)

export default component.exports